import type { AdChatResponse } from '@module/apis/client-side/chat/type';
import toHalfLetter from './toHalfLetter';

const checkIsAdChat = (adChatData: AdChatResponse, message: string): boolean => {
  if (!adChatData || !adChatData.adWords.length) return false;

  // 1. 반각문자로 변환
  let replacedMessage = toHalfLetter(message);
  // 2. 영숫자와 한글을 제외한 모든 문자 제거
  replacedMessage = replacedMessage.replace(/[^a-zA-Z0-9가-힣ㄱ-ㅎㅏ-ㅣ]/g, '');
  // 3. 대문자로 변환
  replacedMessage = replacedMessage.toUpperCase();

  // 광고 단어 매칭 확인
  return adChatData.adWords.some((adWord) => replacedMessage.match(adWord));
};

export default checkIsAdChat;
